import React from 'react';
import PropTypes from 'prop-types';

function ProfileIcon({ id }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 91 91"
      version="1.1"
      viewBox="0 0 91 91"
      xmlSpace="preserve"
      role="img"
      aria-labelledby="profile-icon-title"
    >
      <title id="profile-icon-title">Profile icon</title>
      <g>
        <g transform="translate(6 4)">
          <g>
            <linearGradient
              id={`path-2_2_${id}`}
              x1="-428.467"
              x2="-428.467"
              y1="319.596"
              y2="317.776"
              gradientTransform="matrix(50 0 0 -50 21462.836 15975.786)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" className="startColor" />
              <stop offset="1" className="endColor" />
            </linearGradient>
            <circle
              cx="39.5"
              cy="41.5"
              r="45.5"
              fill={`url(#path-2_2_${id})`}
            />
          </g>
          <g transform="translate(13 10)">
            <g>
              <g>
                <g transform="translate(.167 .833)">
                  <path
                    fill="#EEE"
                    d="M38.2 17c0 3.3-1.3 6.2-3.8 8.6-2.5 2.4-5.6 3.6-9.1 3.6s-6.6-1.2-9.1-3.6c-2.5-2.4-3.8-5.2-3.8-8.6 0-3.3 1.3-6.2 3.8-8.6 2.5-2.4 5.6-3.6 9.1-3.6s6.6 1.2 9.1 3.6c2.5 2.4 3.8 5.3 3.8 8.6z"
                  />
                  <path
                    fill="#6AA9FF"
                    d="M47.3 47.4c0 2.8-.8 5-2.5 6.6-1.6 1.6-3.8 2.4-6.5 2.4H13.8c-2.6 0-4.8-.8-6.5-2.4-1.7-1.6-2.5-3.9-2.5-6.6 0-1.1 0-2.1.1-3.1s.2-2.2.4-3.3c.2-1.2.5-2.3.8-3.4.3-1.1.8-2.1 1.3-3.1.6-1 1.2-2 2-2.7.8-.8 1.8-1.4 2.9-1.9 1.1-.5 2.4-.7 3.7-.7.5 0 1 .2 2 .9.6.4 1.3.9 2.1 1.4.7.4 1.6.9 2.7 1.2 1 .3 2 .5 3 .5h.3c1.1 0 2.2-.2 3.3-.6 1.1-.4 2-.8 2.7-1.2.8-.5 1.5-1 2.1-1.4 1-.7 1.5-.9 2-.9 1.3 0 2.6.2 3.7.7 1.1.5 2.1 1.1 2.9 1.9.8.8 1.4 1.7 2 2.7.6 1 1 2.1 1.3 3.1.3 1 .6 2.2.8 3.4.2 1.2.3 2.3.4 3.3-.1 1.1 0 2.1 0 3.2z"
                  />
                  <path
                    fill="#FFF"
                    d="M26 29.1V4.8c3.3 0 6.2 1.2 8.6 3.6 2.4 2.4 3.6 5.2 3.6 8.6 0 3.3-1.2 6.2-3.6 8.6-2.3 2.4-5.2 3.5-8.6 3.5z"
                  />
                  <path
                    fill="#2682FF"
                    d="M47.3 47.4c0 2.8-.8 5-2.5 6.6-1.6 1.6-3.8 2.4-6.4 2.4H26V33.2h.3c1.1 0 2.2-.2 3.2-.6 1.1-.4 2-.8 2.6-1.2.8-.5 1.5-1 2-1.4 1-.7 1.4-.9 2-.9 1.3 0 2.5.2 3.6.7 1.1.5 2.1 1.1 2.8 1.9.7.8 1.4 1.7 2 2.7.5 1 1 2.1 1.3 3.1.3 1 .6 2.2.8 3.4.2 1.2.3 2.3.4 3.3.2 1.1.3 2.1.3 3.2z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

ProfileIcon.propTypes = {
  id: PropTypes.string,
};

ProfileIcon.defaultProps = {
  id: '',
};

export default React.memo(ProfileIcon);
